export default __webpack_public_path__ + "static/media/affiliate-commission-mobile-banner-cn.13f1903a.webp";